export const DIGEST_DEFAULTS = {
  arrivals:     { enabled: true,  withinDays: 7,  roles: ['admin', 'project_lead'] },
  deliveries:   { enabled: true,  withinDays: 7,  roles: ['admin', 'project_lead'] },
  overdue:      { enabled: true,               roles: ['admin', 'project_lead'] },
  new_projects: { enabled: true,               roles: ['admin', 'project_lead'] },
  my_projects:  { enabled: true,               roles: ['technician', 'project_lead', 'inspector'] },
  training:     { enabled: false, withinDays: 30, roles: ['trainer', 'admin'] },
}
